"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKebabIcon = exports.getButtonAppearance = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireDefault(require("react"));
var _getButtonTextColor = require("../button/styled/getButtonTextColor");
const getKebabIcon = props => {
  const textColor = (0, _getButtonTextColor.getButtonTextColor)({
    appearance: props.appearance,
    state: {
      isDisabled: false,
      isActive: false,
      isFocus: false,
      isHover: false
    },
    themeMode: props.themeMode
  });
  switch (props.themeMode) {
    case "lodestar-light":
      return /*#__PURE__*/_react.default.createElement(_lodestarIcons.KebabIcon, {
        size: props.size,
        color: props.appearance === "borderless" ? (0, _designTokensReact.color)("color--text--neutral--strong", _designTokens.lodestarColors.neutralDark40) : textColor
      });
    case "ursa-light":
    default:
      return /*#__PURE__*/_react.default.createElement(_ursaIcons.MoreIcon, {
        size: props.size === "medium" ? 24 : 20,
        color: textColor
      });
  }
};
exports.getKebabIcon = getKebabIcon;
const getButtonAppearance = themeMode => {
  switch (themeMode) {
    case "lodestar-light":
      return "borderless";
    case "ursa-light":
    default:
      return "secondary-empty";
  }
};
exports.getButtonAppearance = getButtonAppearance;
//# sourceMappingURL=kebabMenuTheme.js.map